export default "__VITE_ASSET__CoYHm6eE__"